import { TAKAYAMA_MATSU } from './takayama-matsu.js';
import { TAKAYAMA_TAKE } from './takayama-take.js';
import { TAKAYAMA_UME } from './takayama-ume.js';

/**
 * 高山一軒家（民泊）の備品見積り。松・竹・梅の3プラン。
 *
 * 出どころは「【備品リスト】高山一軒家_松竹梅_20260929.xlsx」の居室別一覧。
 * 3プランとも品目の並びは同じで、選んだ商品と金額だけが違う。
 *
 * 品目の項目:
 *   place   … 居室
 *   name    … 品目
 *   qty     … 数量
 *   how     … 手配区分（弊社手配／工事側／既設／要確認）。工事側や既設には金額が無い
 *   product … そのプランで選んだ商品
 *   unit    … 単価(円)
 *   total   … 金額(円)
 *   sku     … CG に置いた家具と結びつける名前（src/data/plans/takayama.js の furniture）
 *
 * sku の付いた品目は 3D の家具をクリックすると値段が出る。
 * 付いていない品目（綿棒・洗剤などの小物）は形にできないので、
 * spots の場所に「その他の備品」としてまとめて出す。
 */
export const TAKAYAMA_QUOTE = Object.freeze({
  title: '高山一軒家 備品見積り',
  source: '【備品リスト】高山一軒家_松竹梅_20260929.xlsx',
  note: '見積り時点の金額で、発注価格ではありません。',
  defaultPlan: 'take',
  plans: Object.freeze([TAKAYAMA_MATSU, TAKAYAMA_TAKE, TAKAYAMA_UME]),

  /**
   * 居室ごとの、CG の中の場所 [x, y, z]。
   * y はその居室の床の高さで、まとめの札はここから少し上に浮かせて出す。
   * 見積りの居室名をそのまま鍵にしている。
   */
  spots: Object.freeze({
    '玄関・土間': [5.65, 0, 7.2],
    '廊下・ホール（1階）': [7.0, 0, 4.6],
    リビング: [4.7, 0, 3.4],
    小上がり和室: [1.8, 0.35, 2.15],
    キッチン: [9.5, 0, 5.2],
    洗面脱衣室: [8.5, 0, 1.0],
    浴室: [10.5, 0, 1.2],
    'トイレ（1階）': [10.8, 0, 2.5],
    サウナ室: [7.0, 0, 1.0],
    '水風呂・ととのいスペース': [8.6, 0, 9.5],
    '備品庫・収納': [10.75, 0, 7.6],
    '2階 寝室1（洋室・シングル2台）': [8.2, 2.75, 1.7],
    '2階 寝室2・寝室3（ダブル各2台）': [8.4, 2.75, 5.6],
    '2階 寝室（3室共通）': [8.6, 2.75, 9.2],
    'トイレ（2階）': [10.85, 2.75, 1.0],
    '屋外・駐車場': [5.65, 0, 8.6],
    '共通（全室・館内）': [7.0, 0, 5.8],
  }),
});
